export { default } from "./components/LeaseConfiguration";
